import {GameRandom, Inject, ModelEvents, Singleton} from "@denishussar/html5-game-engine";

export enum CardColorsEnum {
    color0 = "purple",
    color1 = "blue",
    color2 = "yellow",
    color3 = "gray",
}

export enum CardLabelsEnum {
    label0 = "master_card",
    label1 = "mir",
    label2 = "visa",
}

@Singleton
export class PrintCardModel {
    public labels = new Array();
    public colors = new Array();
    public lever = "lever_up"
    public press = "press_up"
    public color = CardColorsEnum.color0
    public label = CardLabelsEnum.label0
    public selectedLabel = "not_chosen"
    public selectedColor = "not_chosen"

    constructor(
        @Inject private _$random: GameRandom,
        @Inject private _$modelEvents: ModelEvents
    ) {
        for (let i = 0; i < 3; i++) {
            this.labels.push(CardLabelsEnum[`label${i}`]);
        }
        for (let i = 0; i < 4; i++) {
            this.colors.push(CardColorsEnum[`color${i}`]);
        }
    }
}
